(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "babel-runtime/helpers/extends", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/helpers/extends"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react);
    global.ConfirmIconSvg = mod.exports;
  }
})(this, function (exports, _extends2, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ConfirmIcon = function ConfirmIcon(props) {
    return _react2.default.createElement(
      "svg",
      (0, _extends3.default)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 56,
        height: 56,
        viewBox: "0 0 56 56"
      }, props),
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "confirm-icon-a", cx: 28, cy: 28, r: 28 }),
        _react2.default.createElement("path", {
          id: "confirm-icon-c",
          d: "M13.875 24.929L7.446 18.5l-2.189 2.174 8.618 8.618 18.5-18.5-2.174-2.174z"
        })
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "mask",
          { id: "confirm-icon-b", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#confirm-icon-a" })
        ),
        _react2.default.createElement("use", { fill: "#DFE1E7", xlinkHref: "#confirm-icon-a" }),
        _react2.default.createElement("circle", {
          cx: 28,
          cy: 28,
          r: 18,
          fill: "#757D99",
          mask: "url(#confirm-icon-b)"
        }),
        _react2.default.createElement("path", {
          fill: "#DFE1E7",
          d: "M35 14h12v10H35z",
          mask: "url(#confirm-icon-b)",
          transform: "rotate(-46 41 19)"
        }),
        _react2.default.createElement("circle", {
          cx: 28,
          cy: 28,
          r: 14,
          fill: "#DFE1E7",
          mask: "url(#confirm-icon-b)"
        }),
        _react2.default.createElement(
          "g",
          { mask: "url(#confirm-icon-b)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(14 5)" },
            _react2.default.createElement("path", { d: "M0 0h37v37H0z" }),
            _react2.default.createElement(
              "mask",
              { id: "d", fill: "#fff" },
              _react2.default.createElement("use", { xlinkHref: "#confirm-icon-c" })
            ),
            _react2.default.createElement("use", { fill: "#000", xlinkHref: "#confirm-icon-c" }),
            _react2.default.createElement(
              "g",
              { fill: "#2D344B", mask: "url(#d)" },
              _react2.default.createElement("path", { d: "M0 0h37v37H0z" })
            )
          )
        )
      )
    );
  };

  exports.default = ConfirmIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/icons/ConfirmIcon.svg.js
// module id = 2013
// module chunks = 1